export default {
  feedback: {
    token_required: 'Clicca sulla casella per verificare di essere umano',
    frequent_requests:
      'Controlla i tuoi SMS. Abbiamo già inviato il codice al numero indicato via SMS. In caso contrario, verifica il numero di telefono o riprova tra 10 minuti.',
  },
};
